import requester from '../requester';

const create = (data) => {
  return requester.post('/api/environments', data);
};

const getAll = () => {
  return requester.get(`/api/environments`);
};

const remove = (id) => {
  return requester.delete(`/api/environments/${id}`);
};

const update = (data, id) => {
  return requester.put(`/api/environments/${id}`, data);
};

const SectorEnvironmentService = {
  create,
  getAll,
  remove,
  update
};

export default SectorEnvironmentService;
